export default {
    computed: {
        hasOrganizationBranding() {
            return !!this.organizationBranding;
        }
    },

    methods: {
        setPageTitle() {
            const brandingName = this.organizationBranding?.name || this.organizationBranding?.organizationName || null;
            if (brandingName) {
                document.title = brandingName;
            }
        },

        setOrganizationFavicon() {
            let organizationFaviconUrl = null;
            if (this.hasOrganizationBranding && !!this.organizationBranding?.favicon) {
                let favIconFilePath = this.organizationBranding.favicon.attributes.filePath;

                if (favIconFilePath.startsWith('/')) {
                    favIconFilePath = favIconFilePath.substring(1);
                }

                organizationFaviconUrl = [
                    window.env.MILESTONES_API_HOST,
                    'storage',
                    favIconFilePath
                ].join('/');
            }

            const favicon = document.querySelectorAll('[rel="icon"]')[0];
            favicon.href = organizationFaviconUrl || require('../../assets/images/favicon.png');
        },
    }
};
